// src/modules/app-views/_apps/appmulti/operators/pages/Init/modals/OperatorsParametersModal/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback, useEffect } from 'react';
import { Modal, Tabs } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OperatorsParametersModal = ({ show, setShow, afterClose, initialTab, resetInitialTab }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const defaultTab = 'general';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState(initialTab || defaultTab);
  const [loading, setLoading] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (show && initialTab) {
      setActiveTab(initialTab);
    }
  }, [show, initialTab]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleClose = useCallback(() => {
    if (!loading) {
      setShow(false);
    }
  }, [loading, setShow]);

  const handleAfterClose = useCallback(() => {
    setActiveTab(defaultTab);
    setLoading(false);
    resetInitialTab?.();
    afterClose?.();
  }, [afterClose, resetInitialTab, defaultTab]);

  const handleTabChange = useCallback(key => {
    setActiveTab(key);
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const tabItems = [
    {
      key: 'general',
      label: translateX('general'),
      children: (
        <div style={{ padding: '16px 0' }}>
          <p className="text-muted">{translateX('no_parameters_available')}</p>
        </div>
      ),
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Modal
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <SettingOutlined />
          {translateX('parameters')}
        </span>
      }
      open={show}
      onCancel={handleClose}
      afterClose={handleAfterClose}
      destroyOnHidden
      width={480}
      footer={null}
      mask={{ closable: !loading }}
      styles={{
        body: {
          maxHeight: 'calc(80vh - 110px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
      style={{ top: '10vh' }}
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabItems}
        style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
        className="parameters-modal-tabs"
      />
    </Modal>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OperatorsParametersModal;
